"use strict";

var loadAsset = function loadAsset(src, callback) {
		// preload if asset is image
		if (src.toLowerCase().match("jpg|jpeg|gif|png|webp") !== null) {
				var image = new Image();
				image.src = src;
				image.onload = callback;
		}

		// preload if asset is video
		if (src.toLowerCase().match("mp4|webm|ogv") !== null) {
				var video = document.createElement('video');
				var source = document.createElement('source');
				source.src = src;
				video.setAttribute("preload", "auto");
				video.appendChild(source);
				video.addEventListener('canplaythrough', callback, false);
		}
};

var loadAssets = function loadAssets(assets, onLoad) {
		var _self = this,
		    totalAssets = assets.length,
		    loadedAssets = 0;

		// Start loading all the assets
		Array.prototype.forEach.call(assets, function (asset) {
				loadAsset(asset.src, function (e) {
						loadedAssets++;
						if (loadedAssets == totalAssets) {

								// when all the assets are loaded call the callback function if any
								if (typeof onLoad === "function") onLoad();
						}
				});
		});
};

module.exports = {
		loadAsset: loadAsset,
		loadAssets: loadAssets
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/preloadAssets.js
// module id = 356
// module chunks = 0